export const defaultIconWidgetOptions = [
  ['hand-holding-heart', 'Anziano'],
  ['baby', 'Fanciullo'],
  ['child', 'Giovane'],
  ['house-user', 'Famiglia'],
  ['user-graduate', 'Studente'],
  ['users', 'Associazione'],
  ['school', 'Istruzione'],
  ['house', 'Abitazione'],
  ['paw', 'Animale domestico'],
  ['people-arrows', 'Integrazione sociale'],
  ['hands-praying', 'Protezione sociale'],
  ['file-lines', "Programma d'azione"],
  ['comments', 'Comunicazione'],
  ['landmark', 'Edificio urbano'],
  ['city', 'Urbanistica ed edilizia'],
  ['microscope', 'Formazione professionale'],
  ['chalkboard-user', 'Acquisizione di conoscenza'],
  ['helmet-safety', 'Condizioni e organizzazione del lavoro'],
  ['bus', 'Trasporto'],
  ['heart', 'Matrimonio'],
  ['person-booth', 'Procedura elettorale e voto'],
  ['masks-theater', 'Tempo libero'],
  ['book', 'Cultura'],
  ['passport', 'Immigrazione'],
  ['smog', 'Inquinamento'],
  ['square-parking', 'Area di parcheggio'],
  ['traffic-light', 'Traffico urbano'],
  ['water', 'Acqua'],
  ['recycle', 'Gestione dei rifiuti'],
  ['heart-pulse', 'Salute'],
  ['user-shield', 'Sicurezza pubblica'],
  ['earth-europe', 'Sicurezza internazionale'],
  ['tree', 'Spazio verde'],
  ['volleyball', 'Sport'],
  ['car', 'Trasporto stradale'],
  ['cart-flatbed-suitcase', 'Turismo'],
  ['plug', 'Energia'],
  ['laptop-code', 'Informatica e trattamento dei dati'],
];
